import { render, staticRenderFns } from "./QuestionText.vue?vue&type=template&id=104b7156&"
import script from "./QuestionText.vue?vue&type=script&lang=js&"
export * from "./QuestionText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports